<template>
    <v-container fluid>
        <v-toolbar color="secondary" dense>
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text">Search</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-actions class="pa-5">
                    <v-row justify="start" class="ml-5">
                        <v-col cols="4">
                            <v-combobox
                                label="Select a Option"
                                dense
                                :items="options"
                                :item-text="'name'"
                                :item-value="'name'"
                                auto-select-first
                                required
                                v-model="option"
                            ></v-combobox>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                dense
                                v-model="searchV"
                                label="Search"
                            ></v-text-field>
                        </v-col>
                        <v-btn
                            small
                            color="secondary"
                            class="my-auto"
                            dense
                            required
                            @click="validate()"
                            ><v-icon>mdi-magnify</v-icon></v-btn
                        >
                    </v-row>
                </v-card-actions>
                <v-container fluid>
                    <v-data-table
                        fluid
                        :headers="header"
                        :items="resultSR"
                        hide-default-footer
                        dense
                        disable-sort
                    >
                        <template v-slot:item.action="{ item }">
                            <v-icon
                                class="mx-3"
                                color="primary"
                                dark
                                @click="openModal(item)"
                                >mdi-open-in-new</v-icon
                            >
                        </template>

                        <template v-slot:item.OpenOrd="{ item }">
                            <td>
                                <v-btn
                                    color="secondary"
                                    @click="openViewDocs(item, 'Order')"
                                    small
                                    class="float-left"
                                    icon
                                    ><v-icon>mdi-image-search</v-icon></v-btn
                                >
                            </td>
                        </template>
                        <template v-slot:item.OpenShft="{ item }">
                            <td>
                                <v-btn
                                    color="secondary"
                                    @click="openViewDocs(item), 'ShiftDetail'"
                                    small
                                    class="float-left"
                                    icon
                                    ><v-icon>mdi-image-search</v-icon></v-btn
                                >
                            </td>
                        </template>
                    </v-data-table>
                </v-container>
                <v-dialog
                    v-model="$store.state.posting.dialog"
                    max-width="1366px"
                    transition="dialog-transition"
                >
                    <OrderData
                        v-if="$store.state.posting.dialog"
                        :parms="params"
                    />
                </v-dialog>
            </v-form>
        </v-card>
        <documents
            v-if="openSearch"
            :openSearch="openSearch"
            :order="order"
            :type="type"
            @close="openSearch = false"
        ></documents>
    </v-container>
</template>
<script>
import { mask } from 'vue-the-mask';
import OrderData from './../Modals/Administration/OrderEdit.vue';
import documents from './../Paperwork/SearchModaView.vue';
import axios from 'axios';
export default {
    name: 'PayrollHrly',
    directives: { mask },
    components: {
        OrderData,
        documents
    },
    data: function() {
        return {
            iterator: false,
            params: '',
            openSearch: false,
            key: [
                { text: 'BOL', value: 'order[BOL]', width: '10%' },
                {
                    text: 'Transaction Type',
                    value: 'tran_type[TranType]',
                    width: '20%'
                },
                {
                    text: 'Terminal',
                    value: 'order[terminal][TerminalName]',
                    width: '10%'
                },
                {
                    text: 'Station',
                    value: 'order[station][Name]',
                    width: '10%'
                },
                { text: 'City', value: 'order[station][City]', width: '5%' },
                { text: 'KMs', value: 'order[Kms]', width: '5%' },
                {
                    text: 'Product',
                    value: 'product.Product',
                    width: '5%'
                },
                { text: 'Quantity', value: 'Quantity', width: '5%' },
                { text: 'Rate', value: 'Rate', width: '5%' },
                { text: 'Amout', value: 'Amount', width: '5%' }
            ],
            header: [
                { text: 'Action', value: 'action', width: '' },
                { text: 'OrderID #', value: 'OrderID', width: '5%' },
                { text: '#', value: 'OpenOrd', width: '5%' },
                { text: 'BOL #', value: 'BillOfLading', width: '5%' },
                { text: 'Order Status', value: 'OrderStatus', width: '5%' },
                { text: 'ShiftDetail', value: 'ShiftDetail', width: '5%' },
                { text: '#', value: 'OpenShft', width: '5%' },
                {
                    text: 'Date',
                    value: 'shift_detail.shift_header.Date',
                    width: '10%'
                },
                {
                    text: 'Driver Name',
                    value: 'shift_detail.driver.Name',
                    width: '20%'
                },
                {
                    text: 'Truck',
                    value: 'shift_detail.truck.Truck',
                    width: '5%'
                },
                {
                    text: 'Trailer',
                    value: 'shift_detail.trailer.Trailer',
                    width: '8%'
                },
                { text: 'Station', value: 'station.Name', width: '15%' },
                {
                    text: 'Terminal',
                    value: 'terminal.TerminalName',
                    width: '15%'
                },
                {
                    text: 'PreloadOrderID',
                    value: 'PreloadOrderID',
                    width: '15%'
                }
            ],
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            itemsPerPageArray: [4, 8, 12],
            search: '',
            filter: {},
            sortDesc: false,
            page: 1,
            ct: 0,
            type: null,
            cbx: '',
            dataOrders: [],
            itemsPerPage: 4,
            sortBy: 'name',
            ordersNum: [],
            valid: true,
            orders: [],
            order: [],
            option: '',
            searchV: '',
            resultSR: [],
            srData: [],
            options: [
                {
                    name: 'Order'
                },
                {
                    name: 'BOL'
                }
            ]
        };
    },
    computed: {
        numberOfPages() {
            return Math.ceil(this.items.length / this.itemsPerPage);
        },
        filteredKeys() {
            return this.keys.filter(key => key !== 'Name');
        }
    },
    methods: {
        openViewDocs: function(item, type) {
            this.order = item;
            this.type = type;
            this.openSearch = true;
        },
        loadOptions: async function() {
            var params = {
                stype: this.option.name,
                svalue: this.searchV
            };

            console.log(params);
            try {
                let response = await axios.post('/order/search', params, {
                    //Just chage router Api
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                });
                this.resultSR = response.data;
                console.log(this.resultSR);
                await this.loadOrdersNumber();
                await this.loadOrders();

                this.dialog = false;
            } catch (error) {
                console.log(error);
            }
        },
        chargeOrders() {
            for (let j = 0; j < this.resultSR.length; j++) {
                for (
                    let i = 0;
                    i < this.resultSR[j].order_details.length;
                    i++
                ) {
                    console.log(this.resultSR[j].order_details[i]);
                    this.srData.push(this.resultSR[j].order_details[i]);
                }
            }
            console.log(this.srData);
        },
        loadOrdersNumber() {
            var a = [];
            this.chargeOrders();
            for (let i = 0; i < this.srData.length; i++) {
                a.push(this.srData[i].OrderID);
            }
            this.ordersNum = a.filter(function(item, pos, self) {
                return self.indexOf(item) == pos;
            });
            console.log(this.ordersNum);
        },
        loadOrders: async function() {
            for (let i = 0; i < this.ordersNum.length; i++) {
                const data = await this.srData.filter(
                    x => x.OrderID === this.ordersNum[i]
                );
                await this.dataOrders.push(data);
            }
            console.log(this.dataOrders);
            this.iterator = true;
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.loadOptions();
            }
        },
        nextPage() {
            if (this.page + 1 <= this.ordersNum.length) {
                this.page += 1;
                this.ct += 1;
            }
        },
        formerPage() {
            if (this.page - 1 >= 1) {
                this.page -= 1;
                this.ct -= 1;
            }
        },
        updateItemsPerPage() {
            console.log(this.ordersNum.indexOf(this.cbx));
            this.page = this.ordersNum.indexOf(this.cbx) + 1;
            this.ct = this.ordersNum.indexOf(this.cbx);
        },
        openModal(itm) {
            this.$store.state.orderInfo.orderId = itm.OrderID;
            this.$store.state.posting.dialog = true;
        }
    }
};
</script>
